import {
  MultiplexNormalizationJobParams,
  NormalizationConfig,
  NormalizationMethod,
} from 'interfaces/jobs/multiplex/normalizationParams';
import { MAX_UINT16, MAX_UINT8 } from 'utils/constants';
import * as yup from 'yup';

export const defaultChannelNormalizationConfig: NormalizationConfig = {
  isLowDynamicRange: false,
  isHighAbundance: false,
  isLowNoise: false,
  params8bit: { startingHistValue: 0, maxMinC: 85, minMaxC: 30, maxMaxC: MAX_UINT8 },
  params16bit: { startingHistValue: 0, maxMinC: 21845, minMaxC: 2000, maxMaxC: MAX_UINT16 },
  maxCPercentile: 0.95,
};

export const defaultNormalizationParams: MultiplexNormalizationJobParams = {
  method: NormalizationMethod.Auto,
  channels: [],
  modelUrl: null,
  baseParams: {},
  paramOverrideChannelGroups: [],
  resultName: null,
  resultDescription: null,
  internallyApproved: true,
};

export const normalizationSchema = yup.object({
  isLowDynamicRange: yup.boolean().when('isHighAbundance', {
    is: true,
    then: yup.boolean().isFalse('Cannot be true when High Abundance is selected'),
  }),
  params8bit: yup.object({
    startingHistValue: yup.number().required(),
    maxMinC: yup.number().required(),
    minMaxC: yup
      .number()
      .required()
      .min(yup.ref('startingHistValue'), 'minMaxC must be greater than startingHistValue'),
    maxMaxC: yup.number().required(),
  }),
  params16bit: yup.object({
    startingHistValue: yup.number().required(),
    maxMinC: yup.number().required(),
    minMaxC: yup
      .number()
      .required()
      .min(yup.ref('startingHistValue'), 'minMaxC must be greater than startingHistValue'),
    maxMaxC: yup.number().required(),
  }),
});
